"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassyAdminView = void 0;
const Log_1 = __importDefault(require("@common/Log"));
const AdminView_1 = require("@frontend/views/AdminView");
const CustomDashboardTab_1 = require("./CustomDashboardTab");
const CustomResultsTab_1 = require("./CustomResultsTab");
class ClassyAdminView extends AdminView_1.AdminView {
    constructor(remoteUrl, tabs) {
        Log_1.default.info("CustomAdminView::<init>(..)");
        super(remoteUrl, Object.assign({}, tabs, { teams: false }));
        this.resultsTab = new CustomResultsTab_1.CustomResultsTab(remoteUrl);
        this.dashTab = new CustomDashboardTab_1.CustomDashboardTab(remoteUrl);
    }
    renderPage(name, opts) {
        Log_1.default.info("CustomAdminView::renderPage( " + name + ", ... ) - start; options: " + JSON.stringify(opts));
        super.renderPage(name, opts);
        if (this.isAdmin === false) {
            Log_1.default.info("CustomAdminView::renderPage( " + name + ", ... ) - !isAdmin");
            this.setTabVisibility("AdminGradeTab", false);
            this.setTabVisibility("AdminDashboardTab", false);
            this.setTabVisibility("AdminResultTab", false);
        }
        else {
            Log_1.default.info("CustomAdminView::renderPage( " + name + ", ... ) - isAdmin");
        }
    }
    handleAdminDashboard(opts) {
        const _super = Object.create(null, {
            handleAdminDashboard: { get: () => super.handleAdminDashboard }
        });
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("CustomAdminView::handleDashboard(..) - start");
            return _super.handleAdminDashboard.call(this, opts);
        });
    }
    handleAdminResults(opts) {
        const _super = Object.create(null, {
            handleAdminResults: { get: () => super.handleAdminResults }
        });
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("CustomAdminView::handleResults(..) - start");
            return _super.handleAdminResults.call(this, opts);
        });
    }
}
exports.ClassyAdminView = ClassyAdminView;
